module.exports = __webpack_public_path__ + "static/img/nyj-logo.c022eb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nyj-logo.jpg
// module id = 4PUM
// module chunks = 52